import {IAmplitudeOfferPromotionTrackingParams} from "../../../promotion/tracking/get_amplitude_offer_promotion_event_properties";
import {OFFER_LISTING_PROMOTION_TAB_LISTING_ANALYTICS_ID} from "../constants/offer_listing_promotion_tabs";

export const getAmplitudeOfferListingPromotionTabSelectTrackingContext = (): IAmplitudeOfferPromotionTrackingParams => ({
    creativeName: OFFER_LISTING_PROMOTION_TAB_LISTING_ANALYTICS_ID,
    creativeSlot: OFFER_LISTING_PROMOTION_TAB_LISTING_ANALYTICS_ID,
    promotionName: OFFER_LISTING_PROMOTION_TAB_LISTING_ANALYTICS_ID,
    promotionContent: OFFER_LISTING_PROMOTION_TAB_LISTING_ANALYTICS_ID,
    location: "listing_page"
});
import {IAmplitudeOfferPromotionTrackingParams} from "../../../promotion/tracking/get_amplitude_offer_promotion_event_properties";
import {OFFER_LISTING_PROMOTION_TAB_LISTING_ANALYTICS_ID} from "../constants/offer_listing_promotion_tabs";

export const getAmplitudeOfferListingPromotionTabSelectTrackingContext = (): IAmplitudeOfferPromotionTrackingParams => ({
    creativeName: OFFER_LISTING_PROMOTION_TAB_LISTING_ANALYTICS_ID,
    creativeSlot: OFFER_LISTING_PROMOTION_TAB_LISTING_ANALYTICS_ID,
    promotionName: OFFER_LISTING_PROMOTION_TAB_LISTING_ANALYTICS_ID,
    promotionContent: OFFER_LISTING_PROMOTION_TAB_LISTING_ANALYTICS_ID,
    location: "listing_page"
});
